import * as API from '../../utils/api'

const FETCH = 'FETCH_VIEW_DATA'
const FETCH_SINGLE = 'FETCH_VIEW_DATA_SINGLE'

const INITIAL_STATE = {
  records: {},
  lists: {},
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${FETCH}_FULFILLED`: {
      const { data } = action.payload
      const { viewId, opts } = action.meta
      const { offset, query } = opts

      let newData = data

      if (offset > 0) {
        const oldData =
          (state.lists[viewId] && state.lists[viewId][query]) || []

        newData = oldData.slice()
        newData.splice(offset, data.length, ...data)
      }

      return {
        ...state,
        lists: {
          ...state.lists,
          [viewId]: {
            ...state.lists[viewId],
            [query]: newData,
          },
        },
      }
    }

    case `${FETCH_SINGLE}_FULFILLED`: {
      const { data } = action.payload
      const { viewId } = action.meta

      return {
        ...state,
        records: {
          ...state.records,
          [viewId]: {
            ...state.records[viewId],
            [data.__pk]: data,
          },
        },
      }
    }

    default:
      return state
  }
}

// Actions

export const fetchViewData = (viewId, opts) => ({
  type: FETCH,
  meta: { viewId, opts },
  payload: API.fetchViewData(viewId, opts),
})

export const fetchViewDetailsData = (viewId, id) => ({
  type: FETCH_SINGLE,
  meta: { viewId },
  payload: API.fetchViewDetailsData(viewId, id),
})

// Selectors

export const getViewData = (viewId, query) => state => {
  const view = state.data.lists[viewId]

  return view && view[query]
}

export const getRecord = (viewId, id) => state => {
  const records = state.data.records[viewId]

  return records && records[id]
}
